import { fileConstants } from "../constants";
import moment from "moment";

let user = JSON.parse(localStorage.getItem("PortalUserSettings"));
let subUser = JSON.parse(localStorage.getItem("SubUserSettings"));

let downloadLoadingForFiles = localStorage.getItem("downloadLoadingForFiles");

const currentUser = subUser || user || {};
const filesSettings = (currentUser.gridsSettings || []).filter(
  (item) => item.gridId === "files"
)[0];
const hiddenColumns = (filesSettings && filesSettings.visibleColumns) || [];
const initialState = {
  selectedFiles: [],
  selectedFlowIdsChannels: [],
  items: null,
  hiddenColumns,
  columnToShowMenu: "",
  downloadLoading: !!downloadLoadingForFiles,
  downloadFileParams: null,
  emailSent: false,
  emailDownloadFileParams: null,
}

const isOldFile = (file) => {
  const arrivalTime = moment.utc(file.file.timestamp, moment.ISO_8601).toDate();
  let _activeFileLimitDate = moment.utc().toDate();
  _activeFileLimitDate.setDate(
    _activeFileLimitDate.getDate() - (window.ActiveFileMaxAgeDays || 2)
  );
  return arrivalTime.getTime() < _activeFileLimitDate.getTime();
};

export function files(
  state = initialState,
  action
) {
  switch (action.type) {
    case fileConstants.SET_EMAIL_FAILED_BUT_DOWNLOAD_READY:
      return {
        ...state,
        emailDownloadFileParams: action.emailDownloadFileParams,
      };
    case fileConstants.SET_EMAIL_SENT:
      return {
        ...state,
        emailSent: action.emailSent,
      };
    case fileConstants.SET_DOWNLOAD_FILE_PARAMS:
      return {
        ...state,
        downloadFileParams: action.downloadFileParams,
      };
    case fileConstants.TOGGLE_DOWNLOAD_SPINNER:
      let defaultDownloadStates = {};
      if (action.showSpinner) {
        defaultDownloadStates = {
          downloadFileParams: null,
          emailSent: false,
          emailDownloadFileParams: null,
        };
      }
      return {
        ...state,
        downloadLoading: action.showSpinner,
        ...defaultDownloadStates,
      };
    case fileConstants.GET_DOWNLOAD_REQUEST:
      return {
        ...state,
        //downloadLoading: true
      };
    case fileConstants.GET_DOWNLOAD_SUCCESS:
      return {
        ...state,
        //downloadLoading: false
      };

    case fileConstants.SET_HIDDEN_COLUMNS:
      return {
        ...state,
        hiddenColumns: [...action.hiddenColumns],
      };
    case fileConstants.TOGGLE_SHOW_COLUMN_MENU:
      return {
        ...state,
        columnToShowMenu:
          action.column === state.columnToShowMenu ? "" : action.column,
      };
    case fileConstants.TOGGLE_HIDDEN_COLUMNS:
      let hiddenColumns = (state.hiddenColumns || []).slice(0);
      var index = hiddenColumns.indexOf(action.column);
      if (index >= 0) {
        hiddenColumns.splice(index, 1);
      } else {
        hiddenColumns.push(action.column);
      }
      return {
        ...state,
        hiddenColumns,
      };
    case fileConstants.TOGGLE_SELECT_ALL:
      const validItems = (state.items || []).filter((file) => !isOldFile(file));
      if (
        state.selectedFiles &&
        validItems &&
        validItems.length > 0 &&
        state.selectedFiles.length < validItems.length
      ) {
        var _allFiles = [];
        if (validItems && validItems.length) {
          validItems.forEach((item) => _allFiles.push(item.fidfs));
        }
        return { ...state, selectedFiles: _allFiles };
      } else {
        return { ...state, selectedFiles: [] };
      }
    case fileConstants.TOGGLE_SELECTION:
      var _selectedFiles = state.selectedFiles.slice(0);
      var _index = _selectedFiles.indexOf(action.fileId);
      if (_index > -1) {
        _selectedFiles.splice(_index, 1);
      } else {
        _selectedFiles.push(action.fileId);
      }
      return { ...state, selectedFiles: _selectedFiles };

    case fileConstants.TOGGLE_CHANNEL_SELECTION:
      var _selectedFlowIdsChannels = (
        state.selectedFlowIdsChannels || []
      ).slice(0);
      var _flowIdChannelIndex = _selectedFlowIdsChannels.findIndex(
        (o) => o.FlowIdFileStart === action.fileId
      );
      const _channelOperator = {
        Channel: action.channelName,
      };
      if (action.channelOperator)
        _channelOperator["Operator"] = action.channelOperator;
      if (_flowIdChannelIndex > -1) {
        /* var _chIndex = (_selectedFlowIdsChannels[_flowIdChannelIndex].Channels || [])
					.indexOf(action.channelName); */
        var _chIndex = (
          _selectedFlowIdsChannels[_flowIdChannelIndex].ChannelsOperators || []
        ).findIndex(
          (o) =>
            o.Channel === action.channelName &&
            ((!o.Operator && !action.channelOperator) ||
              o.Operator === action.channelOperator)
        );
        if (_chIndex > -1) {
          _selectedFlowIdsChannels[
            _flowIdChannelIndex
          ].ChannelsOperators.splice(_chIndex, 1);
          if (
            _selectedFlowIdsChannels[_flowIdChannelIndex].ChannelsOperators
              .length === 0
          ) {
            _selectedFlowIdsChannels.splice(_flowIdChannelIndex, 1);
          }
        } else {
          _selectedFlowIdsChannels[_flowIdChannelIndex].ChannelsOperators.push(
            _channelOperator
          );
        }
      } else {
        _selectedFlowIdsChannels.push({
          FlowIdFileStart: action.fileId,
          ChannelsOperators: [_channelOperator],
        });
      }
      return { ...state, selectedFlowIdsChannels: _selectedFlowIdsChannels };
    case fileConstants.RESET_CHANNEL_SELECTION:
      return { ...state, selectedFlowIdsChannels: [] };
    case fileConstants.CLEAR_FILES:
      return {
        ...state,
        selectedFiles: [],
        selectedFlowIdsChannels: [],
        items: null,
        cleared: true,
      };
    case fileConstants.FILES_RESET:
      return initialState;
    case fileConstants.GETALL_REQUEST:
      return {
        ...state,
        items: null,
        selectedFiles: [],
        selectedFlowIdsChannels: [],
        loading: true,
      };
    case fileConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.files,
        TotalPages: action.TotalPages,
      };
    case fileConstants.GET_BY_FILEID_SUCCESS:
      return {
        ...state,
        items: action.files,
        listFromFileLoaded: true,
        TotalPages: action.TotalPages || 0,
        params: action.params,
      };
    case fileConstants.GET_ALL_START_FILES_DETAILS_SUCCESS:
      return {
        ...state,
        items: action.files,
        listFromFileLoaded: true,
        TotalPages: action.TotalPages || 0,
        params: action.params,
      };

    case fileConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case fileConstants.EXPAND_ROW:
      if (state.items && state.items.length) {
        let _item = state.items[action.rowIndex];
        _item.expanded = !_item.expanded;
      }
      return {
        ...state,
      };
    case fileConstants.SET_ACTIVE_ROW:
      if (state.items && state.items.length) {
        var oldActiveRow = state.items.filter(function (obj) {
          return obj.isActive;
        })[0];

        if (oldActiveRow) {
          oldActiveRow.isActive = false;
        }

        let _item = state.items[action.rowIndex];
        _item.isActive = true;
      }
      return { ...state };
    default:
      return state;
  }
}
